export const nzEmploymentStatusOptions = [
  { label: "Permanent full or part time", value: "FULL_TIME" },
  { label: "Casual/Seasonal/Temporary", value: "CASUAL" },
  { label: "Contractor – fixed term", value: "CONTRACTOR_FULL_TIME" },
  { label: "Contractor – self employed", value: "CONTRACTOR_PART_TIME" },
  { label: "Self-employed", value: "SELF_EMPLOYED" },
  { label: "Superannuation/Government Benefit", value: "SUPERANNUATION" },
  { label: "ACC", value: "ACC" },
  { label: "Rental income", value: "RENTAL_INCOME" },
  { label: "Investment", value: "INVESTMENT" },
] as const;
